import { render, staticRenderFns } from "./goods_up_down.vue?vue&type=template&id=514e5781&scoped=true&"
import script from "./goods_up_down.vue?vue&type=script&lang=js&"
export * from "./goods_up_down.vue?vue&type=script&lang=js&"
import style0 from "./goods_up_down.vue?vue&type=style&index=0&id=514e5781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e5781",
  null
  
)

export default component.exports